<template>
  <div>
    <div>
      <fade-alert-danger ref="danger" :msg="alert.error" />
    </div>
    <b-row>
      <b-col lg="6" md="6" sm="12" class="div-row-padding">
        <b-form-group label="Status" label-for="input-process-displayName">
          <b-form-select :options="optionsStage" v-model="model.statusId"></b-form-select>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row v-for="field in processValues" :key="field.fieldId">
      <b-col>
        <workflow-fill-field :field="field" :fieldId="field.fieldId" :modelstate="modelstate"
          :stage="false"></workflow-fill-field>
        <!-- <div v-for="additionalField in getListAdditionalField(field)" :key="additionalField.fieldId">
          <workflow-fill-field :field="additionalField" :fieldId="additionalField.fieldId" :modelstate="modelstate"
            :stage="false">
          </workflow-fill-field>
        </div> -->
      </b-col>
    </b-row>
  </div>
</template>

<script>
import AwesomeMask from "awesome-mask";
export default {
  name: "ProcessFillEdit",
  props: {
    processFilledId: String,
    readonly: Boolean,
    isSubmitting: Boolean,
  },
  components: {
    'fade-alert-danger': () => import("@/components/FadeAlertDanger.vue"),
    WorkflowFillField: () =>
      import("@/components_rms/workflow/WorkflowFillField.vue"),
  },
  directives: {
    mask: AwesomeMask,
  },
  created() { },
  computed: {
    isSubmittingProperty: {
      get: function () {
        return this.isSubmitting;
      },
      set: function (value) {
        this.$emit("update:isSubmitting", value);
      },
    },
    statusIdComputed() {
      if (!this.model) return;
      if (this.model == null) return;
      if (!this.model.statusId) return;
      if (this.model.statusId == null) return;
      return this.model.statusId;
    },
    processValues() {
      let fields = [];
      if (this.model != null) {
        if (this.model.values) {
          for (let field of this.model.values) {
            fields.push(field);
          }
        }
        if (this.model.additionalFields) {
          for (let field of this.model.additionalFields) {
            fields.push(field);
          }
        }
      }
      return fields.sort((a1, a2) =>
        a1.sequenceNumber < a2.sequenceNumber
      );
    },
  },
  data() {
    return {
      alert: {
        error: "",
        success: "Processo editado com sucesso",
      },
      model: {},
      modelstate: null,
      optionsStage: [],
    };
  },
  mounted() {
    this.model = {};
    this.modelstate = {};
    this.loadData();
  },
  methods: {
    activeProcess() {
      this.isSubmittingProperty = true;
      this.$apiWorkflow
        .post("/processFilled/active/" + this.processFilledId)
        .then((response) => {
          this.isSubmittingProperty = false;
          this.model.active = "Sim";
          this.$forceUpdate;
        });
    },
    getAdditionalFields() {
      if (!this.model) return;
      if (!this.model.id) return;
      if (!this.model.statusId) return;
      this.$apiWorkflow
        .get("/addtionalFields/" + this.model.statusId + "/" + this.model.id)
        .then((response) => {
          console.log("response");
          console.log(response.data);
          let additionalFieldsNew = [];
          let additionalFieldsResponse = response.data;
          if (additionalFieldsResponse) {
            for (let additionalField of additionalFieldsResponse) {
              if (
                !this.model.values.some(
                  (e) => e.fieldId == additionalField.fieldId
                )
              ) {
                additionalFieldsNew.push(additionalField);
              }
            }
          }
          this.model.additionalFields = additionalFieldsNew;
        });
    },
    disableProcess() {
      this.isSubmittingProperty = true;
      this.$apiWorkflow
        .post("/processFilled/disable/" + this.processFilledId)
        .then((response) => {
          this.isSubmittingProperty = false;
          this.model.active = "Não";
          this.$forceUpdate;
        });
    },
    getOptions() {
      this.$apiWorkflow
        .get("/stage/allStage/" + this.model.processId)
        .then((response) => {
          console.log(response.data);
          this.optionsStage = response.data;
        });
    },
    hasChanges() {
      let totalFields = this.model.values.length;
      for (let i = 0; i < totalFields; i++) {
        if (this.model.values[i].value != this.model.values[i].oldValue) {
          return true;
        }
      }
      return false;
    },
    loadData() {
      this.$apiWorkflow
        .get("/processFilled/getFilled/" + this.processFilledId)
        .then((response) => {
          // console.log(response.data);
          this.model = response.data;
          this.oldValues = response.data.values;
          this.getOptions();
        });
    },
    save() {
      this.isSubmittingProperty = true;
      this.$apiWorkflow
        .post("/fieldValue/save/", this.model)
        .then((response) => {
          this.isSubmittingProperty = false;
          this.$emit("refreshData");
        })
        .catch((error) => {
          this.isSubmittingProperty = false;
          if (error.response.status == 401) {
            console.log(error.response.data);
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            if (error.response) {
              console.log(error.response.data);
              if (error.response.data) {
                if (error.response.data.errorMessage) {
                  this.modelstate = {};
                  this.alert.error = `${error.response.data.errorMessage}`;
                  this.$refs.danger.show();
                } else {
                  if (error.response.status == 400) {
                    if (error.response.data.errors) {
                      this.alert.error = "Verifique os valores informados";
                      this.modelstate = error.response.data.errors;
                      console.log(this.modelstate)
                      // console.log(this.modelstate);
                      // console.log(Object.values(this.modelstate)[0][0]);
                      // for (let erroModelState of Object.values(
                      //   this.modelstate
                      // )) {
                      //   console.log(erroModelState[0]);
                      //   // console.log(Object.values(erroModelState)[0])
                      //   this.alert.error += `${erroModelState[0]}`;
                      // }
                    } else {
                      this.alert.error = `${error.response.status} - ${error.response.statusText}\n${error.response.data}`;
                      this.modelstate = error.response.data.errors;
                    }
                    this.$refs.danger.show();
                  } else {
                    this.modelstate = {};
                    this.alert.error = `${error.response.status} - ${error.response.statusText}\n${error.response.data}`;
                    this.$refs.danger.show();
                  }
                }
              } else {
                this.modelstate = {};
                this.alert.error = `${error.response.status} - ${error.response.statusText}\n${error.response.data}`;
                this.$refs.danger.show();
              }
            } else {
              this.modelstate = {};
              this.alert.error = error.message;
              this.$refs.danger.show();
            }
            // if (error.response) {
            //   if (error.response.status == 400) {
            //     console.log(error.response.data);
            //     this.modelstate = error.response.data.errors;
            //   }
            // }
            // this.alert.error = error.message;
            // this.$refs.danger.show();
          }
          this.isSubmittingProperty = false;
        });
    },
    show() {
      this.model = {};
      this.modelstate = {};
      this.loadData();
      // this.getOptions();
    },
  },
  watch: {
    statusIdComputed() {
      this.getAdditionalFields();
    },
    // model: {
    //   handler(newValue, oldValue) {
    //     if (!newValue) {
    //       return;
    //     }
    //     console.log("watch");
    //     console.log(newValue);
    //     console.log(oldValue);
    //     if (oldValue.statusId != newValue.statusId) {
    //       this.getAdditionalFields();
    //       return;
    //     }
    //   },
    //   deep: true,
    // },
  },
};
</script>